import type { MainSubnavItemType, SubnavItemType } from './types';

export const BCC_PLACEHOLDER_NAV_SLUG = 'bcc';

export const MAIN_SUBNAV_ITEMS: MainSubnavItemType[] = [
  {
    label: 'Best Cards',
    href: '/credit-cards/best',
    iconType: 'StarIcon',
    identifier: BCC_PLACEHOLDER_NAV_SLUG,
  },
  {
    label: 'Cash Back',
    href: '/credit-cards/best/cash-back',
    iconType: 'MoneyBagIcon',
    identifier: 'cash-back',
  },
  {
    label: 'Balance Transfer',
    href: '/credit-cards/best/balance-transfer',
    iconType: 'BalanceTransferIcon',
    identifier: 'balance-transfer',
  },
  {
    label: 'Travel',
    href: '/credit-cards/best/travel',
    iconType: 'BaggageIcon',
    identifier: 'travel',
  },
  {
    label: 'Sign-up Bonus',
    href: '/credit-cards/best/bonus-offers',
    iconType: 'GiftIcon',
    identifier: 'bonus-offers',
  },
  {
    label: 'College Student',
    href: '/credit-cards/best/college-student',
    iconType: 'StudentIcon',
    identifier: 'college-student',
  },
  {
    label: 'Secured',
    href: '/credit-cards/best/secured',
    iconType: 'LockIcon',
    identifier: 'secured',
  },
];

export const ALL_SUBNAV_ITEMS: SubnavItemType[] = [
  {
    label: 'Best Cards',
    href: '/credit-cards/best',
    showDividerAfter: true,
    identifier: BCC_PLACEHOLDER_NAV_SLUG,
  },
  {
    label: 'College Student',
    href: '/credit-cards/best/college-student',
    identifier: 'college-student',
  },
  {
    label: 'Excellent Credit',
    href: '/credit-cards/best/excellent-credit',
    identifier: 'excellent-credit',
  },
  {
    label: 'Good Credit',
    href: '/credit-cards/best/good-credit',
    identifier: 'good-credit',
  },
  {
    label: 'Fair Credit',
    href: '/credit-cards/best/fair-credit',
    identifier: 'fair-credit',
  },
  {
    label: 'Bad Credit',
    href: '/credit-cards/best/bad-credit',
    identifier: 'bad-credit',
  },
  {
    label: 'Starter / No Credit',
    href: '/credit-cards/best/no-credit',
    identifier: 'no-credit',
  },
  {
    label: 'Secured',
    href: '/credit-cards/best/secured',
    showDividerAfter: true,
    identifier: 'secured',
  },
  {
    label: 'Travel',
    href: '/credit-cards/best/travel',
    identifier: 'travel',
  },
  {
    label: 'Airline',
    href: '/credit-cards/best/airline',
    identifier: 'airline',
  },
  {
    label: 'Hotel',
    href: '/credit-cards/best/hotel',
    identifier: 'hotel',
  },
  {
    label: 'No Foreign Transaction Fee',
    href: '/credit-cards/best/no-foreign-transaction-fee',
    identifier: 'no-foreign-transaction-fee',
  },
  {
    label: 'Airport Lounge Access',
    href: '/credit-cards/best/airport-lounge-access',
    showDividerAfter: true,
    identifier: 'airport-lounge-access',
  },
  {
    label: 'Cash Back',
    href: '/credit-cards/best/cash-back',
    identifier: 'cash-back',
  },
  {
    label: 'Rewards',
    href: '/credit-cards/best/rewards',
    identifier: 'rewards',
  },
  {
    label: 'Sign-up Bonus',
    href: '/credit-cards/best/bonus-offers',
    identifier: 'bonus-offers',
  },
  {
    label: 'Gas',
    href: '/credit-cards/best/gas',
    identifier: 'gas',
  },
  {
    label: 'Groceries',
    href: '/credit-cards/best/groceries',
    identifier: 'groceries',
  },
  {
    label: 'Restaurants',
    href: '/credit-cards/best/restaurants',
    identifier: 'restaurants',
  },
  {
    label: 'Online Shopping',
    href: '/credit-cards/best/online-shopping',
    identifier: 'online-shopping',
  },
  {
    label: 'Streaming Services',
    href: '/credit-cards/best/streaming-services',
    showDividerAfter: true,
    identifier: 'streaming-services',
  },
  {
    label: 'Balance Transfer',
    href: '/credit-cards/best/balance-transfer',
    identifier: 'balance-transfer',
  },
  {
    label: '0% Intro APR',
    href: '/credit-cards/best/zero-percent',
    identifier: 'zero-percent',
  },
  {
    label: 'No Annual Fee',
    href: '/credit-cards/best/no-annual-fee',
    identifier: 'no-annual-fee',
  },
  {
    label: 'Low Interest',
    href: '/credit-cards/best/low-interest',
    showDividerAfter: true,
    identifier: 'low-interest',
  },
  {
    label: 'Business',
    href: '/business/credit-cards/best',
    identifier: 'small-business',
  },
];
